import React, { useState } from 'react';
import { service } from '~/src/service';
import { Button, Form, Grid, Header, Image, Message, Segment } from 'semantic-ui-react';
import logo from '~/assets/logo.png';

export const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  return <Grid textAlign='center' style={{ height: '100vh' }} verticalAlign='middle'>
    <Grid.Column style={{ maxWidth: 450 }}>
      <Header as='h2' color='teal' textAlign='center'>
        <Image src={logo} /> Log-in to your account
      </Header>
      <Form size='large'>
        <Segment>
          <Form.Input
            fluid
            icon='user'
            iconPosition='left'
            placeholder='E-mail address'
            value={email}
            onChange={e => setEmail(e.target.value)}
          />
          <Form.Input
            fluid
            icon='lock'
            iconPosition='left'
            placeholder='Password'
            type='password'
            value={password}
            onChange={e => setPassword(e.target.value)}
          />

          <Button color='teal' fluid size='large'
            onClick={e => {
              e.preventDefault();
              service.signInWithEmailAndPassword(email, password);
            }}
          >
            Login
          </Button>
        </Segment>
      </Form>
      <Message>
        <a href='#'>Forgot your password?</a>
      </Message>
      Copyright © <a href='https://craetus.com/'>CRAETUS</a>  {new Date().getFullYear()}
    </Grid.Column>
  </Grid>
}